<vrm-card *ngIf='rewardsData' [cardTitle]='cardTitle' [shadedHeaderLevel]='17'>
  <div class='vrm-card'>
    <mat-accordion displayMode='flat'>
      <mat-expansion-panel class='vrm-summary-expansion no-elevation-but-underline'>
        <mat-expansion-panel-header>
          <div
            class='padding-t-5 margin-r-15 padding-l-5'
            [style.font-size]="cService.isPcViewport ? '16px' : '70%'"
            [style.min-width]="cService.isPcViewport ? '100px' : '50px'"
          >
            {{ cService.getSingleTranslation('MAINSIDENAV.mentorRewards', 'Mentor Rewards') | titlecase }}
          </div>

          <div
            class='custom-chips-container'
            style='font-size: 85%'
            fxLayout='row'
            fxLayoutAlign='space-between'
          >
            <div
              matTooltip="{{ rewardsData?.currentBalance | number }} {{
								cService.getSingleTranslation('REPORTCOLUMNS.Current Points Balance', 'Current Points Balance')
							}}"
            >
							<span *ngIf='!cService.isPcViewport' class='bold'>{{
                rewardsData?.currentBalance | number
                }}</span>
              <span *ngIf='cService.isPcViewport'
              >{{ rewardsData?.currentBalance | number }}
                {{ cService.getSingleTranslation('REPORTCOLUMNS.Current Points Balance', 'Current Points Balance') }}</span
              >
            </div>

            <div
              matTooltip="{{ rewardsData?.lifetimeRewards | number }} {{
                cService.getSingleTranslation('REPORTCOLUMNS.Lifetime Points Total', 'Lifetime Points Total')
							}}"
            >
							<span *ngIf='!cService.isPcViewport' class='bold'>{{
                rewardsData?.lifetimeRewards | number
                }}</span>
              <span *ngIf='cService.isPcViewport'
              >{{ rewardsData?.lifetimeRewards | number }}
                {{ cService.getSingleTranslation('REPORTCOLUMNS.Lifetime Points Total', 'Lifetime Points Total') }}</span
              >
            </div>

            <div
              matTooltip="{{ rewardsData?.numberOfEarnedBadges }} {{
                cService.getSingleTranslation('REPORTCOLUMNS.Badges Earned', 'Badges Earned')
							}}"
            >
							<span *ngIf='!cService.isPcViewport' class='bold'>{{
                rewardsData?.numberOfEarnedBadges
                }}</span>
              <span *ngIf='cService.isPcViewport'
              >{{ rewardsData?.numberOfEarnedBadges }}
                {{ cService.getSingleTranslation('REPORTCOLUMNS.Badges Earned', 'Badges Earned') }}</span
              >
            </div>
          </div>
        </mat-expansion-panel-header>

        <!-- Badges list -->
        <div *ngIf='rewardsData?.earnedBadges.length; else noRewardsFound'>
          <table class='raw-table' *ngFor='let badge of rewardsData?.earnedBadges'>
            <tr>
              <td>{{ cService.getSingleTranslation('REPORTCOLUMNS.badgeName', 'Badge Name') }}</td>
              <td>
                <strong>{{ cService.getSingleTranslation('REPORTDATA.' + badge.badgeName, badge.badgeName) }}</strong>
                <small class='playlist-name'>
                  {{ cService.getSingleTranslation('REPORTDATA.' + badge.badgeName + ' Description', badge.badgeDescription) }}
                </small>
              </td>
            </tr>

            <tr>
              <td>{{ cService.getSingleTranslation('REPORTCOLUMNS.dateAwarded', 'Date Awarded') }}</td>
              <td>{{ badge.dateAwarded | date: 'yyyy-MM-dd' }}</td>
            </tr>

            <tr>
              <td>{{ cService.getSingleTranslation('REPORTCOLUMNS.pointsAwarded', 'Points Awarded') }}</td>
              <td class='green-text'>{{ badge.pointsAwarded }}</td>
            </tr>
          </table>
        </div>
        <ng-template #noRewardsFound>
          <div class='no-badges-found' [style.font-size]="cService.isPcViewport ? '16px' : '70%'">
            <span class='margin-10'>{{ 'GENERIC.No Badges Found' | translate }}</span>
          </div>
        </ng-template>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</vrm-card>
